import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_single_answer = _resolveComponent("single-answer")!
  const _component_multiple_answer = _resolveComponent("multiple-answer")!
  const _component_free_text = _resolveComponent("free-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: "my-5",
    key: _ctx.question.quiz_uuid
  }, [
    (_ctx.question.type === _ctx.QuestionTypes.SINGLE_QUESTION)
      ? (_openBlock(), _createBlock(_component_single_answer, {
          key: 0,
          question: _ctx.question
        }, null, 8, ["question"]))
      : (_ctx.question.type === _ctx.QuestionTypes.MULTIPLE_QUESTION)
        ? (_openBlock(), _createBlock(_component_multiple_answer, {
            key: 1,
            question: _ctx.question
          }, null, 8, ["question"]))
        : (_ctx.question.type === _ctx.QuestionTypes.OPEN_QUESTION)
          ? (_openBlock(), _createBlock(_component_free_text, {
              key: 2,
              question: _ctx.question
            }, null, 8, ["question"]))
          : _createCommentVNode("", true)
  ]))
}